module.exports = __webpack_public_path__ + "img/20.59f0b6e9.jpg";